import React, { lazy } from "react";
import Faq from "../components/faq";


import Form from "../components/Form";
const FeaturesBenifits = lazy(() => import("../components/FeaturesBenifits"));
const Disclaimer = lazy(() => import("../components/disclaimer"));
const Footer = lazy(() => import("../components/Footer"));


function Home({ customADL, setCustomADL }) {
  return (
    <>
      <Form customADL={customADL} setCustomADL={setCustomADL} />
      <FeaturesBenifits />
      <Faq customADL={customADL} setCustomADL={setCustomADL} />
      <Disclaimer  />
      <Footer  />
    </>
  );
}

export default Home;
